// Replace this URL with your actual Google Apps Script Web App URL
const GOOGLE_APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxzYczdCrJxl54ffdEDGQCnwvGf2WcjQFancRxv1xaMB3T6yaoh9Sq6eW-yPsh67QSj/exec';

export const getInventory = async () => {
  try {
    const response = await fetch(`${GOOGLE_APPS_SCRIPT_URL}?action=getInventory`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching inventory:', error);
    return [];
  }
};

export const getItem = async (id) => {
  try {
    const response = await fetch(`${GOOGLE_APPS_SCRIPT_URL}?action=getItem&id=${id}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching item:', error);
    return null;
  }
};

export const updateStock = async (id, newStock) => {
  try {
    const response = await fetch(`${GOOGLE_APPS_SCRIPT_URL}?action=updateStock&id=${id}&stock=${newStock}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating stock:', error);
    return { error: 'Update failed' };
  }
};

export const addItem = async (itemData) => {
  try {
    const formData = new FormData();
    formData.append('action', 'addItem');
    Object.keys(itemData).forEach(key => {
      formData.append(key, itemData[key]);
    });

    const response = await fetch(GOOGLE_APPS_SCRIPT_URL, {
      method: 'POST',
      body: formData
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error adding item:', error);
    return { error: 'Add failed' };
  }
};

export const updateItem = async (id, itemData) => {
  try {
    const formData = new FormData();
    formData.append('action', 'updateItem');
    formData.append('id', id);
    Object.keys(itemData).forEach(key => {
      formData.append(key, itemData[key]);
    });

    const response = await fetch(GOOGLE_APPS_SCRIPT_URL, {
      method: 'POST',
      body: formData
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating item:', error);
    return { error: 'Update failed' };
  }
};

export const getItemByBarcode = async (barcode) => {
  try {
    const response = await fetch(`${GOOGLE_APPS_SCRIPT_URL}?action=getItemByBarcode&barcode=${barcode}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching item by barcode:', error);
    return { error: 'Barcode lookup failed' };
  }
};

export const updateStockByBarcode = async (barcode, newStock) => {
  try {
    const response = await fetch(`${GOOGLE_APPS_SCRIPT_URL}?action=updateStockByBarcode&barcode=${barcode}&stock=${newStock}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating stock by barcode:', error);
    return { error: 'Barcode stock update failed' };
  }
};